export default __webpack_public_path__ + "dbfa559c1f386a2adda11d81c9343395.svg";